"use strict";

exports.__esModule = true;
exports.EnrichDefinitionContext = void 0;
var _Utils = require("../../Utils");
var EnrichDefinitionContext = exports.EnrichDefinitionContext = (0, _Utils.createEnhancedContext)({
  propName: "enrichDefinition"
});